import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import Heading from '../text/Heading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';

const NoresultsWrapper = styled.div`
  text-align: center;
  .noresults__icon {
    color: ${getTheme('textColor', 'baseLight')};
    font-size: ${getTheme('fontSize', 'display')};
  }
  .noresults__heading {
    font-weight: 300;
    color: ${getTheme('textColor', 'altLight')};
  }
  .noresults__text {
    font-size: ${getTheme('fontSize', 'note')};
    font-weight: 600;
  }
`;

class Noresults extends Component {
  render() {
    return (
      <NoresultsWrapper>
        <div className="noresults">
          <div className="noresults__icon">
            <FontAwesomeIcon icon={faExclamationCircle} />
          </div>
          {this.props.heading && (
            <Heading level="heading2">
              <h3 className="noresults__heading">{this.props.heading}</h3>
            </Heading>
          )}
          {this.props.text && <p className="noresults__text">{this.props.text}</p>}
          {this.props.noresultsButton}
        </div>
      </NoresultsWrapper>
    );
  }
}

export default Noresults;



// WEBPACK FOOTER //
// ./src/components/noresults/Noresults.js